/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as AdminDefs from '../../../com/atproto/admin/defs.defs.js'
import * as SignatureDefs from './defs.defs.js'

const $nsid = 'tools.ozone.signature.findRelatedAccounts'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  did: /*#__PURE__*/ l.string({ format: 'did' }),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 100 }),
      50,
    ),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  accounts: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<RelatedAccount>((() => relatedAccount) as any),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get accounts that share some matching threat signatures with the root account. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

export const $lxm = $nsid

type RelatedAccount = {
  $type?: 'tools.ozone.signature.findRelatedAccounts#relatedAccount'
  account: AdminDefs.AccountView
  similarities?: SignatureDefs.SigDetail[]
}

export type { RelatedAccount }

const relatedAccount = /*#__PURE__*/ l.typedObject<RelatedAccount>(
  $nsid,
  'relatedAccount',
  /*#__PURE__*/ l.object({
    account: /*#__PURE__*/ l.ref<AdminDefs.AccountView>(
      (() => AdminDefs.accountView) as any,
    ),
    similarities: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<SignatureDefs.SigDetail>(
          (() => SignatureDefs.sigDetail) as any,
        ),
      ),
    ),
  }),
)

export { relatedAccount }
